// import { combineReducers } from "redux";
import { persistCombineReducers } from "redux-persist";
import storage from "redux-persist/lib/storage";

// import { persistConfig } from "../../store";
import userReducer from "./userReducer";
import savingsReducer from "./savingsReducer";
import investmentsReducer from "./investmentsReducer";
import loansReducer from "./loansReducer";
import transactionsReducer from "./transactionsReducer";

const persistConfig = {
  key: "peristPayload",
  storage: storage,
  whitelist: ["users", "investments", "loans", "transactions"], // which reducer want to store
};

export default persistCombineReducers(persistConfig, {
  userReducer,
  savingsReducer,
  investmentsReducer,
  loansReducer,
  transactionsReducer,
});
